import { render, staticRenderFns } from "./analizcompyeni1.vue?vue&type=template&id=c12e0b72"
import script from "./analizcompyeni1.vue?vue&type=script&lang=js"
export * from "./analizcompyeni1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports